<div class="principal-therapeutic-uses-container">
  <div class="principal-therapeutic-uses-item-container">
    <div class="principal-therapeutic-uses-item-input-container">
      <mat-form-field appearance="outline" class="principal-therapeutic-uses-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <textarea matInput #principalTherapeuticUsesInput 
          [(ngModel)]="principalTherapeuticUses" rows="3"
          class="principalTherapeuticUses principal-therapeutic-uses-item-input"
          (keyup.enter)="updatePrincipalTherapeuticUses($event)" (keyup.escape)="cancelUpdate()" 
          (blur)="updatePrincipalTherapeuticUses($event)"></textarea>
        <mat-icon matSuffix (mousedown)="clearPrincipalTherapeuticUsesInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  
    <div class="input-error" *ngIf="hasFieldValidationError('principalTherapeuticUses')">
      This is a required field.
    </div>
  </div>
    <div class="principal-therapeutic-uses-info principal-therapeutic-uses-info-text">
     List the indications, diseases, or conditions for which this substance is being clinically investigated.
    </div>
</div>
